<div>
  <div [formGroup]="form" class="mt-4 mx-auto">
    <div class="flex justify-between items-center mb-5 -mx-2">
      <div class="w-full px-2">
        <div class="box-form">
          <h4 class="bg-gray">Origem</h4>
          <div class="input-box flex flex-col items-center w-full">
            <div class="flex justify-between items-center -mx-2 w-full">
              <mat-form-field
                class="input-tg w-4/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Descrição</mat-label>
                <input matInput formControlName="originDescription" />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-4/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Cidade</mat-label>
                <input matInput formControlName="originCity" />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-4/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Estado</mat-label>
                <input matInput formControlName="originState" />
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-between items-center mt-8 mb-5 -mx-2">
      <div class="w-full px-2">
        <div class="box-form">
          <h4 class="bg-gray">Destino</h4>
          <div class="input-box flex flex-col items-center w-full">
            <div class="flex justify-between items-center -mx-2 w-full">
              <mat-form-field
                class="input-tg w-4/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Descrição</mat-label>
                <input matInput formControlName="destinationDescription" />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-4/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Cidade</mat-label>
                <input matInput formControlName="destinationCity" />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-4/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Estado</mat-label>
                <input matInput formControlName="destinationState" />
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-between items-center mt-3 -mx-2">
      <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
        <mat-label>Tipo Tarifário</mat-label>
        <mat-select formControlName="tariffType">
          <mat-option [value]="0">Todos</mat-option>
          @for (type of listTypeTariff; track type) {
            <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
        <mat-label>Perimetro Urbano</mat-label>
        <mat-select formControlName="urbanPerimeter">
          @for (type of listPerimeter; track type) {
            <mat-option [value]="type.value">{{ type.description }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
        <mat-label>Tipo Serviço</mat-label>
        <mat-select
          formControlName="serviceType"
          (selectionChange)="onSelectionChangeServiceSpecification($event)"
        >
          <mat-option [value]="0">Todos</mat-option>
          @for (type of listTypeService; track type) {
            <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
        <mat-label>Serviço</mat-label>
        <mat-select
          formControlName="specificationService"
          (selectionChange)="onSelectionChangeService($event)"
        >
          <mat-option [value]="0">Todos</mat-option>
          @if (listServiceSpecification.length == 0) {
          } @else {
            @for (type of listServiceSpecification; track type) {
              <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
            }
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="flex justify-between items-center mt-3 -mx-2">
      <mat-form-field class="input-tg w-4/12 px-2" appearance="outline">
        <mat-label>Status</mat-label>
        <mat-select formControlName="status">
          @for (type of listStatus; track type) {
            <mat-option [value]="type.value">{{ type.description }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <!--      <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">-->
      <!--        <mat-label>Standard</mat-label>-->
      <!--        <mat-select formControlName="standard">-->
      <!--          @for (type of listStandard; track type) {-->
      <!--            <mat-option [value]="type.value">{{ type.description }}</mat-option>-->
      <!--          }-->
      <!--        </mat-select>-->
      <!--      </mat-form-field>-->
      <mat-form-field class="input-tg w-4/12 px-2" appearance="outline">
        <mat-label>Tipo veículo</mat-label>
        <mat-select formControlName="vehicleType">
          <mat-option [value]="0">Todos</mat-option>
          @for (type of listTypeVehicle; track type) {
            <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="input-tg w-4/12 px-2" appearance="outline">
        <mat-label>Tipo motorista</mat-label>
        <mat-select formControlName="driverType">
          <mat-option [value]="0">Todos</mat-option>
          @for (type of listTypeDriver; track type) {
            <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="mb-3 flex justify-end items-center gap-2">
      <button
        class="btn-icon"
        (click)="sendSearch(false)"
        [matTooltip]="'Limpar Pesquisar'"
      >
        <mat-icon>replay</mat-icon>
      </button>
      <button class="btn-icon" (click)="sendSearch()" [matTooltip]="'Pesquisa'">
        <mat-icon>search</mat-icon>
      </button>
    </div>
  </div>
</div>
